// Theme-aware chart colors using CSS variables
// Brand Gold (#e7ae3a) is the primary color

export const CHART_COLORS = {
  // Primary palette - brand first
  primary: '#e7ae3a',   // Brand gold
  secondary: '#3b82f6', // Blue
  tertiary: '#22c55e',  // Green
  quaternary: '#8b5cf6', // Purple
  quinary: '#ef4444',   // Red
  senary: '#14b8a6',    // Teal
};

// Get an array of chart colors
export const getChartColors = () => [
  CHART_COLORS.primary,
  CHART_COLORS.secondary,
  CHART_COLORS.tertiary,
  CHART_COLORS.quaternary,
  CHART_COLORS.quinary,
  CHART_COLORS.senary,
];

// Theme-aware grid and axis colors
export const getGridColor = (isDark) => isDark ? '#27272a' : '#e4e4e7';
export const getAxisColor = (isDark) => isDark ? '#71717a' : '#71717a';
export const getTooltipBg = (isDark) => isDark ? '#18181b' : '#ffffff';
export const getTooltipBorder = (isDark) => isDark ? '#27272a' : '#e4e4e7';
export const getTextColor = (isDark) => isDark ? '#a1a1aa' : '#52525b';

// Tooltip style for recharts
export const getTooltipStyle = (isDark) => ({
  contentStyle: {
    backgroundColor: getTooltipBg(isDark),
    border: `1px solid ${getTooltipBorder(isDark)}`,
    borderRadius: '8px',
    color: isDark ? '#fafafa' : '#18181b',
  },
  labelStyle: {
    color: isDark ? '#fafafa' : '#18181b',
    fontWeight: 600,
  },
  itemStyle: {
    color: isDark ? '#a1a1aa' : '#52525b',
  },
});
